import {
  DASHBOARD_STORAGE_KEYS,
  isMenuPermissionFilterEnabled,
} from "../../accessControl";

export const MENU_PERMISSIONS_STORAGE_KEY = DASHBOARD_STORAGE_KEYS.permissions;

const normalizePermissions = (storedValue) => {
  if (Array.isArray(storedValue)) {
    return storedValue;
  }

  if (storedValue && Array.isArray(storedValue.data)) {
    return storedValue.data;
  }

  return [];
};

export const getStoredMenuPermissions = () => {
  if (typeof window === "undefined") {
    return [];
  }

  try {
    const rawPermissions = localStorage.getItem(MENU_PERMISSIONS_STORAGE_KEY);

    if (!rawPermissions) {
      return [];
    }

    return normalizePermissions(JSON.parse(rawPermissions));
  } catch (error) {
    console.error("Error reading menu permissions from localStorage:", error);
    return [];
  }
};

const buildAccessMap = (permissions) =>
  permissions.reduce((accessMap, permission) => {
    const permissionId = Number(permission?.id);

    if (Number.isNaN(permissionId)) {
      return accessMap;
    }

    accessMap.set(permissionId, Boolean(permission?.access));
    return accessMap;
  }, new Map());

const hasPermissionAccess = (permissionIds, accessMap) => {
  if (!Array.isArray(permissionIds) || permissionIds.length === 0) {
    return true;
  }

  return permissionIds.some((permissionId) =>
    accessMap.get(Number(permissionId)),
  );
};

const filterMenuBranch = (menuItems, accessMap) =>
  menuItems.reduce((filteredItems, item) => {
    const children = Array.isArray(item.hijos)
      ? filterMenuBranch(item.hijos, accessMap)
      : [];

    const hasVisibleChildren = children.length > 0;
    const hasDirectAccess = hasPermissionAccess(item.permiso, accessMap);
    const shouldShowItem =
      item.indicator || hasDirectAccess || hasVisibleChildren;

    if (!shouldShowItem) {
      return filteredItems;
    }

    filteredItems.push({
      ...item,
      hijos: children,
    });

    return filteredItems;
  }, []);

export const getFilteredMenu = (menuItems) => {
  if (!isMenuPermissionFilterEnabled()) {
    return menuItems;
  }

  const storedPermissions = getStoredMenuPermissions();

  // Mientras no existan permisos cargados, se conserva el menú completo.
  if (storedPermissions.length === 0) {
    return menuItems;
  }

  return filterMenuBranch(menuItems, buildAccessMap(storedPermissions));
};
